import React from 'react';
import styled from 'styled-components';
import { Skeleton } from '@oneaudi/unified-web-components';
import { SYS_SPACE_FIXED_200, SYS_SPACE_RELATIVE_XL } from '@oneaudi/unified-web-common';

export const ToolBarSkeletonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${SYS_SPACE_RELATIVE_XL};
`;
export const ToolBarSkeleton: React.FC = () => {
  return (
    <ToolBarSkeletonContainer>
      <Skeleton
        variant="rectangular"
        width="50px"
        height="16px"
        margin={[SYS_SPACE_FIXED_200, 0, SYS_SPACE_FIXED_200, 0]}
      />
      <Skeleton
        variant="rectangular"
        width="150px"
        height="24px"
        margin={[SYS_SPACE_FIXED_200, 0, SYS_SPACE_FIXED_200, 0]}
      />
    </ToolBarSkeletonContainer>
  );
};
